
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect } from '@/components';
import { AppButton, AppFileUpload, AppImageHolder } from '@/components';
import useAppAdd from '@/modules/apps/model/add';
import { ROUTE_NAME_APPLICATION } from '@/modules/apps/router';

export default defineComponent({
    name: ROUTE_NAME_APPLICATION.ADD,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppButton, AppFileUpload, AppImageHolder },
    setup() {
        const { model, v$, currencyOptions, create } = useAppAdd();

        return { v$, model, currencyOptions, create };
    }
});
